import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Cache } from '@app/cache';

@Injectable({
  providedIn: 'root'
})
export class UserAdminSettingsService extends BaseService {

  private userAdminSettingsCache = [];

  constructor(
    public http: HttpClient,
    public cache: Cache
  ) {
    super(http, cache);
    this.setVars({
      endPoint: 'user/{id}/admin-groups',
      modelTitle: 'AdminSettings'
    });
  }
}
